module.exports = __webpack_public_path__ + "static/media/card.01676419.png";